import * as React from 'react';
import { ResourceForm } from '../../../../components/ResourceForm';
import { useResourceFromOutletContext } from '..';

export function ResourceDetails(): JSX.Element | null {
  // const value = useResource(props.value);
  const { resource, onSubmit, onDelete } = useResourceFromOutletContext();
  return <ResourceForm defaultValue={resource} onSubmit={onSubmit} onDelete={onDelete} formMode="display_only" />;
}
